export const endpoint = process.env.REACT_APP_BACKEND_URL;
export const s3Endpoint = process.env.REACT_APP_S3_URL;
